import { gql } from "@apollo/client";

import { MeetingsOverviewMeeting } from "./meetings-overview-meeting-fragment";

export default gql`
  ${MeetingsOverviewMeeting}
  query getMeetingOverviewMeetingsQuery(
    $participants: [Int]
    $dateRangeStart: DateTime
    $dateRangeEnd: DateTime
    $isOneonone: Boolean
    $searchQuery: String
    $orderBy: String
    $first: Int
    $after: String
    $minimumDateRange: String
  ) {
    meetings(
      participants: $participants
      ignored: false
      startDatetime_Gte: $dateRangeStart
      startDatetime_Lte: $dateRangeEnd
      orderBy: $orderBy
      isFormalOneonone: $isOneonone
      search: $searchQuery
      first: $first
      after: $after
      minimumDateRange: $minimumDateRange
    ) {
      edges {
        node {
          id
          ...MeetingsOverviewMeeting
        }
      }
    }
  }
`;
